export default __webpack_public_path__ + "img/loading.12f38436ff17769e4251bce5f2fd7b2c.gif";